{
  "pt": {
    "whats_new": {
      "category": {
        "news": "Notícia",
        "product": "Atualização de produto",
        "tip": "Dica"
      },
      "category_plural": {
        "news": "Notícias",
        "product": "Atualizações de produto",
        "tip": "Dicas"
      },
      "earlier": "Anteriores",
      "empty_description": "As novas funcionalidades, dicas e notícias da Ziggu aparecem aqui.",
      "empty_title": "Ainda sem publicações",
      "helpful": "Útil",
      "helpful_impersonation": "Não é possível enquanto se faz passar por outra pessoa.",
      "helpful_mark": "Marcar como útil",
      "helpful_marked": "Achou isto útil",
      "image_open": "Abrir imagem {index} de {count}",
      "load_failed_description": "Verifique a ligação e tente novamente.",
      "load_failed_title": "Não foi possível carregar as publicações",
      "new": "Novo",
      "no_matches_description": "Nenhuma publicação corresponde à pesquisa ou aos filtros. Limpe-os para ver tudo.",
      "no_matches_title": "Sem resultados",
      "read_more": "Saber mais",
      "retry": "Tentar novamente",
      "search": "Pesquisar publicações…",
      "subtitle": "Novas funcionalidades, dicas e notícias da equipa Ziggu.",
      "title": "O que há de novo"
    }
  }
}
